(function () {
  var SUPABASE_URL = 'https://xpjjvrjcjouylartupwy.supabase.co';
  var BULK_MIN_QTY = 12;

  function readMeta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') || '' : '';
  }

  function resolveAnonKey(form) {
    return (
      form.getAttribute('data-supabase-anon-key') ||
      document.body.getAttribute('data-supabase-anon-key') ||
      readMeta('supabase-anon-key') ||
      ''
    );
  }

  function setMessage(form, text, isError) {
    var msg = form.querySelector('[data-cart-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('is-visible');
    msg.classList.toggle('is-error', !!isError);
  }

  function fnFetch(anon, fnName, body) {
    return fetch(SUPABASE_URL + '/functions/v1/' + fnName, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + anon,
        apikey: anon,
      },
      body: JSON.stringify(body),
    }).then(function (resp) {
      return resp.json().then(function (data) {
        if (!resp.ok || (data && data.error)) {
          throw new Error((data && (data.details || data.error)) || 'request_failed');
        }
        return data;
      });
    });
  }

  function buildRequestData(form) {
    var fd = new FormData(form);
    var eventDate = String(fd.get('event_date') || '').trim();
    var eventTime = String(fd.get('event_time') || '').trim();
    return {
      eventType: String(fd.get('event_type') || '').trim(),
      eventDate: [eventDate, eventTime].filter(Boolean).join(' '),
      eventTime: eventTime,
      serviceHours: String(fd.get('service_hours') || '').trim(),
      guestCount: Number(fd.get('guest_count') || 0) || null,
      venue: String(fd.get('venue') || '').trim(),
      serviceType: String(fd.get('service_type') || '').trim(),
      dressCode: String(fd.get('dress_code') || '').trim(),
      tipJarAllowed: String(fd.get('tip_jar_allowed') || '').trim(),
      pocName: String(fd.get('poc_name') || '').trim(),
      pocPhone: String(fd.get('poc_phone') || '').trim(),
      outletAvailable: String(fd.get('outlet_available') || '').trim(),
      parkingInfo: String(fd.get('parking_info') || '').trim(),
      specialRequests: String(fd.get('special_requests') || '').trim() || 'none',
    };
  }

  function uploadVenuePhotos(anon, requestId, fileInput) {
    var files = fileInput && fileInput.files ? Array.from(fileInput.files) : [];
    if (!files.length) return Promise.resolve([]);

    return Promise.all(
      files.map(function (file, idx) {
        var path = requestId + '/' + Date.now() + '-' + idx + '-' + file.name.replace(/[^\w.\-]+/g, '_');
        return fetch(SUPABASE_URL + '/storage/v1/object/coffee-cart-venues/' + encodeURIComponent(path).replace(/%2F/g, '/'), {
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + anon,
            apikey: anon,
            'Content-Type': file.type || 'application/octet-stream',
            'x-upsert': 'true',
          },
          body: file,
        }).then(function (resp) {
          if (!resp.ok) throw new Error('venue_upload_failed');
          return path;
        });
      })
    );
  }

  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function showPastryPicker(anon, eventDate, eventTime) {
    return new Promise(function (resolve) {
      var overlay = document.querySelector('[data-pastry-overlay]');
      var body = document.querySelector('[data-pastry-body]');
      var skipBtn = document.querySelector('[data-pastry-skip]');
      var confirmBtn = document.querySelector('[data-pastry-confirm]');
      if (!overlay || !body) {
        resolve({ pastry_interest: false, pastry_lines: [], pastry_subtotal_cents: 0 });
        return;
      }

      var quantities = {};
      var catalogItems = [];

      function finish(withPastry) {
        overlay.hidden = true;
        overlay.style.display = 'none';
        resolve(withPastry);
      }

      skipBtn.onclick = function () {
        finish({ pastry_interest: false, pastry_lines: [], pastry_subtotal_cents: 0 });
      };

      overlay.style.display = 'flex';
      overlay.hidden = false;
      body.innerHTML = '<p>Loading pastry menu…</p>';

      fnFetch(anon, 'coffee-cart-pastry-catalog', {})
        .then(function (data) {
          catalogItems = (data && data.items) || [];
          if (!catalogItems.length) {
            body.innerHTML = '<p>Pastries are not available right now. You can continue without them.</p>';
            confirmBtn.hidden = true;
            return;
          }

          function render() {
            body.innerHTML =
              '<p style="margin:0 0 1rem;font-size:0.9rem;">Fresh pastries from our bakery (minimum ' +
              BULK_MIN_QTY +
              ' per item).</p>' +
              catalogItems
                .map(function (item) {
                  var qty = quantities[item.id] || 0;
                  return (
                    '<div class="be-pastry-item">' +
                    '<div><strong>' +
                    item.displayName +
                    '</strong><br><span style="font-size:0.85rem;">' +
                    formatMoney(item.unitPriceCents) +
                    ' each</span></div>' +
                    '<div><button type="button" data-dec="' +
                    item.id +
                    '">−</button> <span>' +
                    qty +
                    '</span> <button type="button" data-inc="' +
                    item.id +
                    '">+</button></div></div>'
                  );
                })
                .join('');

            body.querySelectorAll('[data-inc]').forEach(function (btn) {
              btn.addEventListener('click', function () {
                var id = btn.getAttribute('data-inc');
                quantities[id] = quantities[id] ? quantities[id] + 1 : BULK_MIN_QTY;
                render();
              });
            });
            body.querySelectorAll('[data-dec]').forEach(function (btn) {
              btn.addEventListener('click', function () {
                var id = btn.getAttribute('data-dec');
                if (!quantities[id]) return;
                if (quantities[id] <= BULK_MIN_QTY) delete quantities[id];
                else quantities[id] -= 1;
                render();
              });
            });
          }

          confirmBtn.hidden = false;
          confirmBtn.onclick = function () {
            var lines = [];
            var subtotal = 0;
            catalogItems.forEach(function (item) {
              var qty = quantities[item.id] || 0;
              if (qty < BULK_MIN_QTY) return;
              lines.push({
                recipe_id: item.recipeId || null,
                recipe_name: item.recipeName || item.displayName,
                square_variation_id: item.squareVariationId,
                quantity: qty,
                unit_price_cents: item.unitPriceCents,
                display_name: item.displayName,
              });
              subtotal += qty * item.unitPriceCents;
            });
            finish({
              pastry_interest: lines.length > 0,
              pastry_lines: lines,
              pastry_subtotal_cents: subtotal,
            });
          };

          render();
        })
        .catch(function () {
          body.innerHTML = '<p>Pastries unavailable — continuing without them.</p>';
          confirmBtn.hidden = true;
        });
    });
  }

  function showSuccess(form, payload, statusUrl) {
    form.hidden = true;
    var success = document.querySelector('[data-cart-success]');
    if (!success) return;
    success.hidden = false;
    var emailEl = success.querySelector('[data-cart-success-email]');
    var passEl = success.querySelector('[data-cart-success-password]');
    var statusLink = success.querySelector('[data-cart-status-link]');
    if (emailEl) emailEl.textContent = payload.email;
    if (passEl) passEl.textContent = payload.password;
    if (statusLink && statusUrl) statusLink.href = statusUrl;
  }

  var CLIENT_REQUEST_KEY = 'blackelm-coffee-cart-client-request-id';

  function clientRequestId() {
    try {
      var existing = sessionStorage.getItem(CLIENT_REQUEST_KEY);
      if (existing) return existing;
      var id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : fallbackUuid();
      sessionStorage.setItem(CLIENT_REQUEST_KEY, id);
      return id;
    } catch (err) {
      return fallbackUuid();
    }
  }

  function fallbackUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function bindForm(form) {
    if (form.getAttribute('data-cart-bound') === '1') return;
    form.setAttribute('data-cart-bound', '1');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.getAttribute('data-submitting') === '1') return;
      form.setAttribute('data-submitting', '1');
      var anon = resolveAnonKey(form);
      if (!anon) {
        form.removeAttribute('data-submitting');
        setMessage(form, 'Configuration error — please call (615) 912-0314.', true);
        return;
      }

      var fd = new FormData(form);
      var lead = {
        name: String(fd.get('name') || '').trim(),
        email: String(fd.get('email') || '').trim().toLowerCase(),
        phone: String(fd.get('phone') || '').trim(),
        password: String(fd.get('password') || '').trim(),
        surface: 'shopify_coffee_cart',
        client_request_id: clientRequestId(),
      };
      var requestData = buildRequestData(form);
      var statusUrl = form.getAttribute('data-status-url') || 'https://blackelm.app/pages/Wholesale/coffee-cart-status-lookup.html';
      var submitBtn = form.querySelector('[type="submit"]');
      var defaultLabel = submitBtn ? (submitBtn.getAttribute('data-default-label') || submitBtn.textContent) : 'Submit';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }

      var requestId = null;

      fnFetch(anon, 'create-coffee-cart-request', lead)
        .then(function (created) {
          requestId = (created.request && created.request.id) || created.id;
          if (!requestId) throw new Error('missing_request_id');
          var photosInput = form.querySelector('[name="venue_photos"]');
          return uploadVenuePhotos(anon, requestId, photosInput).then(function (paths) {
            return fnFetch(anon, 'complete-coffee-cart-request', {
              requestId: requestId,
              requestData: Object.assign({}, requestData, { created_from: 'form' }),
              summary: 'Coffee cart booking submitted via Shopify form',
              status: 'new',
              venuePhotos: paths,
            });
          });
        })
        .then(function () {
          return showPastryPicker(anon, requestData.eventDate, requestData.eventTime);
        })
        .then(function (pastryData) {
          if (!requestId || !pastryData.pastry_interest) return null;
          return fnFetch(anon, 'complete-coffee-cart-request', {
            requestId: requestId,
            requestData: Object.assign({}, requestData, pastryData, { created_from: 'form' }),
            summary: 'Coffee cart booking with pastries via Shopify form',
            status: 'new',
          });
        })
        .then(function () {
          try { sessionStorage.removeItem(CLIENT_REQUEST_KEY); } catch (err) { /* ignore */ }
          showSuccess(form, lead, statusUrl);
        })
        .catch(function (err) {
          setMessage(form, 'Something went wrong: ' + (err.message || 'please try again or call us.'), true);
        })
        .finally(function () {
          form.removeAttribute('data-submitting');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultLabel;
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-coffee-cart-booking-form]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
